import * as React from 'react';
import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { checkPersonalPhoneNumber } from '../../util/utils';
import Title from 'antd/lib/typography/Title';
import { BaseType } from 'antd/lib/typography/Base';

interface VerifyUserPhone2Props {
  user: any;
  authCode: any;
  verifiedAuthCode: any;
  successBtnMsg: string;
  requestAuthCode: (data: any) => void;
  verifyAuthCode: (data: any) => void;
  onPrev?: (data: any) => void;
  onNext?: (data: any) => void;
  updateUserPhone: (data: string) => void;
}

function VerifyUserPhone2({
  user,
  authCode,
  verifiedAuthCode,
  successBtnMsg,
  requestAuthCode,
  verifyAuthCode,
  onPrev,
  updateUserPhone,
}: VerifyUserPhone2Props) {
  const { Text } = Typography;
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  return (
    <>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={18}>
          <Title level={4}>{user.name}님! 휴대전화번호를 인증 해 주세요.</Title>
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={18}>
          <Form
            form={form1}
            name="requestAuthCode"
            layout="inline"
            onFinish={requestAuthCode}
          >
            <Form.Item
              name="phone"
              style={{ width: '60%' }}
              rules={[
                { required: true, message: '휴대전화번호를 입력하세요.' },
                {
                  validator: (_, value) => checkPersonalPhoneNumber(value),
                },
              ]}
            >
              <Input
                placeholder="예) 01012345678"
                disabled={authCode && authCode.type === 'success'}
              />
            </Form.Item>
            <Form.Item shouldUpdate>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={authCode && authCode.type === 'success'}
                >
                  전송
                </Button>
              )}
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Row justify="center">
        {authCode && (
          <Col span={18}>
            <Text type={`${authCode.type}` as BaseType}>
              {authCode.message}
            </Text>
          </Col>
        )}
      </Row>
      {authCode && (
        <>
          <Row justify="center" style={{ marginTop: '20px' }}>
            <Col span={18}>
              <Form
                form={form2}
                name="verifyAuthCode"
                layout="inline"
                onFinish={() =>
                  verifyAuthCode({
                    ...form1.getFieldsValue(),
                    ...form2.getFieldsValue(),
                  })
                }
              >
                <Form.Item
                  name="code"
                  style={{ width: '60%' }}
                  rules={[
                    { required: true, message: '인증번호를 입력하세요.' },
                  ]}
                >
                  <Input disabled={!authCode} />
                </Form.Item>
                <Form.Item shouldUpdate>
                  {() => (
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={
                        verifiedAuthCode && verifiedAuthCode.type === 'success'
                      }
                    >
                      인증
                    </Button>
                  )}
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <Row justify="center">
            {verifiedAuthCode && (
              <Col span={18}>
                <Text type={`${verifiedAuthCode.type}` as BaseType}>
                  {verifiedAuthCode.message}
                </Text>
              </Col>
            )}
          </Row>
        </>
      )}
      <Row justify="center" style={{ marginTop: '20px' }}>
        <Col span={8}>
          <Form.Item>
            <Button
              htmlType="button"
              type="primary"
              style={{ width: '100%' }}
              onClick={() => updateUserPhone(form1.getFieldValue('phone'))}
              disabled={
                !(verifiedAuthCode && verifiedAuthCode.type === 'success')
              }
            >
              {successBtnMsg}
            </Button>
          </Form.Item>
        </Col>
      </Row>
      <Row justify="center">
        <Col span={8}>
          <Button htmlType="button" style={{ width: '100%' }} onClick={onPrev}>
            뒤로
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default VerifyUserPhone2;
